import { injectable } from "inversify";
import CarEntity, { TransmissionCar } from "../../entities/CarEntity";
import OrderByEntity from "../../entities/OrderByEntity";
import CarRepository from "../../repositories/CarRepository";
import StarRatingComponentProps from "../../../presentation/ui/components/starRating/StarRatingComponentProps";

interface props {
    carRepository: CarRepository;
}
interface Response {
    cars: CarEntity[];
    maxPages: number;
    count?: any;
}

@injectable()
export default class SearchCarsUseCase {
    _carRepository: CarRepository;

    constructor(_: props) {
        this._carRepository = _.carRepository;
    }
    async call(
        page: number,
        search: string,
        brand: string | string[] | undefined,
        modelId: string | string[] | undefined,
        year: string | undefined,
        price: { min: number; max: number } | undefined,
        type: string | string[] | undefined,
        transmission: TransmissionCar | TransmissionCar[] | undefined,
        tag: string | string[] | undefined,
        km: { min: number; max: number } | undefined,
        fuelId: string | string[] | undefined,
        colorId: string | string[] | undefined,
        plateNumber: string | string[] | undefined,
        orderBy: OrderByEntity | undefined,
        claims: boolean | undefined,
        amount_claims: number | undefined,
        warranty: boolean | undefined,
        type_warranty: string | undefined,
        types_claims: string | undefined,
        traction: string | string[] | undefined,
        sede: string | string[] | undefined
    ): Promise<Response> {
        return await this._carRepository.search(
            page,
            search,
            brand,
            modelId,
            year,
            price,
            type,
            transmission,
            tag,
            km,
            fuelId,
            colorId,
            plateNumber,
            orderBy,
            claims,
            amount_claims,
            warranty,
            type_warranty,
            types_claims,
            traction,
            sede
        );
    }
}

export const SearchCarsUseCaseName = "SearchCarsUseCaseName";
